{
    "msal": {
      "auth": {
        "clientId": "clientid",
        "authority": "https://login.microsoftonline.com/common/",
        "redirectUri": "http://localhost:4200/",
        "postLogoutRedirectUri": "http://localhost:4200/",
        "navigateToLoginRequestUrl": true
      },
      "cache": {
        "cacheLocation": "localStorage",
        "storeAuthStateInCookie": true
      }
    },
    "guard": {
      "interactionType": "redirect",
      "authRequest": {
        "scopes": ["user.read"]
      },
      "loginFailedRoute": "/login" 
    },
    "interceptor": {
      "interactionType": "redirect",
      "protectedResourceMap": [
        ["https://graph.microsoft.com/v1.0/me", ["user.read"]]
      ]
    }
  }